export default __webpack_public_path__ + "static/media/painting22.4a6d5807.jpg";